<template>
  <div>
    <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <div class="zj-left-header">
          <el-button type="text" @click="onAdd" v-if="IsAdministrator==true">新增</el-button>
          <el-button type="text" @click="onUp" :disabled="isDisabled">上移</el-button>
          <el-button type="text" @click="onDown" :disabled="isDisabled">下移</el-button>
        </div>
        <el-divider></el-divider>
        <div class="zj-left-main">
          <div style="height:450px;">
            <el-tree
              style="{ width }"
              node-key="TreeId"
              :default-expanded-keys="expandkeys"
              :data="Menus"
              :props="defaultProps"
              @node-click="handleNodeClick"
              highlight-current="true"
            ></el-tree>
          </div>
        </div>
      </div>
      <div class="zj-layout-right">
        <div class="zj-layout-main">
          <el-container ref="container" style="height:450px;">
            <el-main>
              <el-form
                ref="menuform"
                status-icon
                :model="menuform"
                :rules="rules"
                label-width="100px"
              >
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单编号" prop="MenuCode">
                      <el-input v-model="menuform.MenuCode" :disabled="IsUpdate"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单名称" prop="MenuName">
                      <el-input v-model="menuform.MenuName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="父级菜单" prop="ParentMenuName">
                      <!-- <el-input v-model="menuform.ParentMenuName"></el-input> -->
                      <el-cascader
                        ref="ParentMenuCascader"
                        v-model="menuform.ParentMenuId"
                        :options="Menus"
                        :props="menuoptionsProps"
                        :show-all-levels="false"
                        filterable
                        @change="ParentMenuChange"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单类型" prop="MenuType">
                      <el-select v-model="menuform.MenuType" placeholder="请选择">
                        <el-option
                          v-for="item in MenuTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="显示类型" prop="DisplayType">
                      <el-select v-model="menuform.DisplayType" placeholder="请选择">
                        <el-option
                          v-for="item in DisplayTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单地址" prop="MenuUrl">
                      <el-input v-model="menuform.MenuUrl"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="图片地址" prop="MenuImg">
                      <el-input v-model="menuform.MenuImg"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单序号" prop="MenuIndex">
                      <el-input-number v-model="menuform.MenuIndex" :min="1" :max="10"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="菜单描述" prop="Description">
                      <el-input
                        type="textarea"
                        :rows="5"
                        v-model="menuform.Description"
                        maxlength="200"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-main>
            <el-footer style="text-align: center;">
              <el-button @click="onSave" :disabled="isDisabled">保存</el-button>
              <el-button @click="onDelete" :disabled="isDisabled" v-if="IsAdministrator==true">删除</el-button>
            </el-footer>
          </el-container>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "MenusPage",
  controller: "UI",
  action: "menus",
  data() {
    return {
      MenuTypeOptions: [
        {
          value: -1,
          label: "请选择",
        },
        {
          value: 0,
          label: "内部",
        },
        {
          value: 1,
          label: "外部",
        },
      ],
      DisplayTypeOptions: [
        {
          value: -1,
          label: "请选择",
        },
        {
          value: 0,
          label: "Web版",
        },
        {
          value: 1,
          label: "Silverlight版",
        },
        {
          value: 2,
          label: "Html5版",
        },
        {
          value: 3,
          label: "MOM组态",
        },
        {
          value: 4,
          label: "Pc版本",
        },
      ],
      Menus: [],
      defaultProps: {
        children: "ChildTreeList",
        label: "TreeName",
      },
      SelectedMenu: "",
      SelecedProductCode: "",
      ParentMenu: "",
      IsAdministrator: false,
      menuform: {
        MenuId: "",
        MenuCode: "",
        MenuName: "",
        ParentMenuId: "",
        ParentMenuName: "",
        MenuType: -1,
        DisplayType: -1,
        MenuUrl: "",
        MenuImg: "",
        MenuIndex: 0,
        Description: "",
      },
      rules: {
        MenuCode: [
          { required: true, message: "请输入菜单编号", trigger: "blur" },
        ],
        MenuName: [
          { required: true, message: "请输入菜单名称", trigger: "blur" },
        ],
      },
      resData: "",
      IsUpdate: true,
      isDisabled: false,
      menuoptionsProps: {
        checkStrictly: true,
        emitPath: false,
        value: "TreeId",
        label: "TreeName",
        children: "ChildTreeList",
      },
      expandkeys: [],
    };
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    this.logInfo.ActionName = "菜单查看";
    this.logInfo.LogMessage = "菜单查看";
    this.logInfo.ModuleName = "权限管理";
    this.logInfo.PageName = "菜单管理页面";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    init() {
      // showLoading(".zj-form-container");
      return utils
        .waitAll(
          [() => this.GetUserIsAdministrator(), () => this.InitMenus()],
          (r) => {
            hideLoading();
            this.IsAdministrator = r[0].data.Data;
            console.log(this.IsAdministrator);
            this.Menus = r[1].data.Data;

            console.log("this.Menus", this.Menus);
          }
        )
        .catch((e) => {
          console.log(e);
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg ? "获取菜单失败!" + e.RspMsg : "获取菜单失败!",
            type: "error",
          });
        });
    },
    GetUserIsAdministrator() {
      let user = this.user;
      var userId = user.UserId;
      let RoleInfoSearch = {
        UserId: userId,
      };

      return new WebApis.RoleApi().IsAdministrator(RoleInfoSearch);
    },
    InitMenus() {
      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;

      let TreeSearch = {
        OrgCode: OrgCode,
        userId: userId,
      };
      console.log(TreeSearch);

      return new WebApis.TreeApi().GetMenuTree(TreeSearch);
    },
    GetMenus(expand_keys) {
      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;

      let TreeSearch = {
        OrgCode: OrgCode,
        userId: userId,
      };

      showLoading(".zj-form-container");

      return new WebApis.TreeApi()
        .GetMenuTree(TreeSearch)
        .then((res) => {
          this.Menus = res.data.Data;
          this.expandkeys = expand_keys;
          hideLoading();
        })
        .catch((e) => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg ? "获取菜单失败!" + e.RspMsg : "获取菜单失败!",
            type: "error",
          });
        });
    },
    handleNodeClick(data) {
      this.SelectedMenu = data;
      this.GetInfo();
    },
    GetInfo() {
      let user = this.user;
      var userId = user.UserId;

      var ProductCode = this.config.app.product_code;

      if (this.SelectedMenu) {
        this.IsUpdate = true;
        this.isDisabled = false;
        if (this.SelectedMenu.TreeLevel == 0) {
          this.ParentMenu = undefined;
          this.SelecedProductCode = this.SelectedMenu.TreeObj.ProductCode;
          this.menuform.MenuCode = this.SelectedMenu.TreeObj.ProductCode;
          this.menuform.MenuName = this.SelectedMenu.TreeName;
          this.menuform.ParentMenuId = "";
          this.menuform.ParentMenuName = "";
          this.menuform.MenuType = -1;
          this.menuform.DisplayType = -1;
          this.menuform.MenuUrl = "";
          this.menuform.MenuImg = "";
          this.menuform.MenuIndex = this.SelectedMenu.TreeObj.OrderIndex;
          this.menuform.Description = "";
          this.isDisabled = true;
          return;
        }

        showLoading(".zj-form-container");
        let MenuInfoSearch = {
          MenuId: this.SelectedMenu.TreeId,
          UserId: userId,
          ProductCode: ProductCode,
        };

        new WebApis.MenuApi()
          .GetItemByMenuId(MenuInfoSearch)
          .then((res) => {
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.menuform.MenuCode = this.resData.MenuCode;
              this.menuform.MenuId = this.resData.MenuId;
              this.menuform.MenuName = this.resData.MenuName;
              this.menuform.ParentMenuId = this.resData.ParentMenuId;
              this.menuform.MenuType = this.resData.MenuType;
              this.menuform.DisplayType = this.resData.DisplayType;
              this.menuform.MenuUrl = this.resData.MenuUrl;
              this.menuform.MenuImg = this.resData.MenuImg;
              this.menuform.MenuIndex = this.resData.MenuIndex;
              this.menuform.Description = this.resData.Description;
              this.SelecedProductCode = this.SelectedMenu.TreeObj.ProductCode;

              if (this.SelectedMenu.TreeLevel == 1) {
                console.log("this.SelectedMenu", this.SelectedMenu);
                let ProductSearch = {
                  ProductCode: this.SelectedMenu.TreeObj.ProductCode,
                };

                new WebApis.ProductApi()
                  .GetItemByProductCode(ProductSearch)
                  .then((productres) => {
                    console.log("productres", productres);
                    if (productres.data.Data) {
                      this.menuform.ParentMenuId = productres.data.Data.LogicId;
                      this.menuform.ParentMenuName =
                        productres.data.Data.ProductName;
                      this.ParentMenu = undefined;
                    }
                  });
              } else {
                MenuInfoSearch = {
                  MenuId: this.menuform.ParentMenuId,
                };
                new WebApis.MenuApi()
                  .GetItemByMenuId(MenuInfoSearch)
                  .then((res1) => {
                    if (res1.data.Data) {
                      this.menuform.ParentMenuName = res1.data.Data.MenuName;
                      this.ParentMenu = res1.data.Data;
                    }
                  });
              }
            }
            hideLoading();
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取菜单信息失败!" + e.RspMsg
                : "获取菜单信息失败!",
              type: "error",
            });
          });
      }
    },
    onAdd() {
      this.isDisabled = false;
      if (this.SelectedMenu) {
        this.IsUpdate = false;
        this.menuform.ParentMenuId = this.menuform.MenuId;
        this.menuform.ParentMenuName = this.menuform.MenuName;
        this.menuform.MenuCode = "";
        this.menuform.MenuName = "";
        this.menuform.MenuType = -1;
        this.menuform.DisplayType = -1;
        this.menuform.MenuUrl = "";
        this.menuform.MenuImg = "";
        this.menuform.MenuIndex = 0;
        this.menuform.Description = "";

        var ParentMenuId = "";
        if (this.SelectedMenu.TreeLevel == 0) {
          this.menuform.ParentMenuId = this.SelectedMenu.TreeId;
          this.menuform.ParentMenuName = this.SelectedMenu.TreeName;
          ParentMenuId = "";
          this.ParentMenu = undefined;
        } else {
          ParentMenuId = this.SelectedMenu.TreeId;
          this.ParentMenu = this.SelectedMenu.TreeObj;
        }

        let MenuInfoSearch = {
          MenuId: ParentMenuId,
          ProductCode: this.SelecedProductCode,
        };
        new WebApis.MenuApi()
          .FindLastMenuIndexByParentMenuId(MenuInfoSearch)
          .then((res) => {
            console.log(res);
            if (res.RspCode == "1") {
              console.log(res.data.Data);
              this.menuform.MenuIndex = res.data.Data + 1;
            }
          });
      } else {
        this.$message({
          showClose: true,
          message: "请选择父目录!",
          type: "error",
        });
      }
    },
    onSave() {
      if (this.SelectedMenu) {
        var Parent_MenuId = "";
        var Menu_Tiers = "";
        var Product_Code = this.SelecedProductCode;
        // if(this.SelectedMenu.TreeLevel>=1)
        // {
        //   Parent_MenuId=this.SelectedMenu.TreeId;
        //   Menu_Tiers=this.SelectedMenu.MenuTiers;
        // }

        if (this.ParentMenu) {
          Parent_MenuId = this.ParentMenu.MenuId;
          Menu_Tiers = this.ParentMenu.MenuTiers;
          Product_Code = this.ParentMenu.ProductCode;
        }

        let MenuInfoDTO = {
          Id: 0,
          MenuId: "",
          MenuCode: this.menuform.MenuCode,
          ProductCode: Product_Code,
          MenuName: this.menuform.MenuName,
          ParentMenuId: Parent_MenuId,
          MenuTiers: Menu_Tiers,
          MenuUrl: this.menuform.MenuUrl,
          MenuType: this.menuform.MenuType,
          DisplayType: this.menuform.DisplayType,
          MenuImg: this.menuform.MenuImg,
          IsSystemTier: 0,
          AllowEdit: 0,
          AllowDelete: 0,
          Description: this.menuform.Description,
          HasFuncs: 0,
          Creater: this.user.UserName,
          CreateTime: new Date(),
          Modifier: this.user.UserName,
          ModifyTime: new Date(),
          Validity: 1,
          Extend1: "",
          Extend2: "",
          SysUrl: "",
          Capitalize: "",
          MenuIndex: this.menuform.MenuIndex,
        };
        if (!this.IsUpdate) {
          this.onInsert(MenuInfoDTO);
        } else {
          MenuInfoDTO.Id = this.SelectedMenu.TreeObj.Id;
          MenuInfoDTO.MenuId = this.SelectedMenu.TreeId;
          //MenuInfoDTO.ParentMenuId=this.SelectedMenu.TreeLevel>1?this.menuform.ParentMenuId:'';
          //MenuInfoDTO.MenuTiers=this.SelectedMenu.TreeObj.MenuTiers;
          MenuInfoDTO.Creater = this.SelectedMenu.TreeObj.Creater;
          MenuInfoDTO.CreateTime = this.SelectedMenu.TreeObj.CreateTime;
          MenuInfoDTO.Modifier = this.user.UserName;
          MenuInfoDTO.ModifyTime = new Date();
          this.onUpdate(MenuInfoDTO);
        }
      } else {
        this.$message({
          showClose: true,
          message: "请选择父目录!",
          type: "error",
        });
      }
    },
    onInsert(MenuInfoDTO) {
      showLoading(".zj-form-container");
      new WebApis.MenuApi()
        .AddItem(MenuInfoDTO)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            let MenuIdArray = [];
            var MenuId = res.data.Data;
            MenuIdArray.push(MenuId);
            this.$message({ message: "用户菜单添加成功!", type: "success" });
            this.GetMenus(MenuIdArray);
          } else {
            hideLoading();
            this.$message({
              showClose: true,
              message: "添加菜单失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "菜单添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户菜单添加成功" : "添加菜单失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "菜单管理页面";
          this.addOperationLog();
        })
        .catch((e) => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加菜单失败！" + e.RspMsg : "添加菜单失败！",
            type: "error",
          });
          return false;
        });
    },
    onUpdate(MenuInfoDTO) {
      showLoading(".zj-form-container");

      let user = this.user;
      var userId = user.UserId;

      var Product_Code = this.config.app.product_code;

      var Org_Code = this.config.app.org_code;

      let MenuInfoSearch = {
        item: MenuInfoDTO,
        UserId: userId,
        ProductCode: Product_Code,
        OrgCode: Org_Code,
      };

      console.log(MenuInfoSearch);

      new WebApis.MenuApi()
        .UpdateItem(MenuInfoSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            this.$message({ message: "用户菜单修改成功!", type: "success" });
            let MenuIdArray = [];
            MenuIdArray.push(MenuInfoDTO.MenuId);
            this.GetMenus(MenuIdArray);
          } else {
            hideLoading();
            this.$message({
              showClose: true,
              message: "修改菜单失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "菜单修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户菜单修改成功" : "修改菜单失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "菜单管理页面";
          this.addOperationLog();
        })
        .catch((e) => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改菜单失败！" + e.RspMsg : "修改菜单失败！",
            type: "error",
          });
          return false;
        });
    },
    onDelete() {
      if (!this.SelectedMenu) {
        this.$message({
          showClose: true,
          message: "请选择要删除的项!",
          type: "error",
        });
        return;
      }

      if (this.SelectedMenu.TreeLevel >= 1) {
        if (
          this.SelectedMenu.ChildTreeList != null &&
          this.SelectedMenu.ChildTreeList.length > 0
        ) {
          this.$message({
            showClose: true,
            message: "有子目录无法删除!",
            type: "error",
          });
          return;
        }

        this.$confirm("确定删除该菜单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let MenuInfoObj = this.SelectedMenu.TreeObj;
          showLoading(".zj-form-container");
          new WebApis.MenuApi()
            .DelItem(MenuInfoObj)
            .then((r) => {
              if (r.RspCode == "1") {
                this.$message({ type: "success", message: "删除成功!" });
                hideLoading();
                let MenuIdArray = [];
                var MenuId = MenuInfoObj.ParentMenuId;
                MenuIdArray.push(MenuId);
                this.GetMenus(MenuIdArray);
                this.onAdd(); //此处用于清空form中的值
              } else {
                hideLoading();
                this.$message({
                  showClose: true,
                  message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                  type: "error",
                });
              }
            })
            .catch((e) => {
              hideLoading();
              this.$message({
                showClose: true,
                message: e.RspMsg
                  ? "删除失败!" + e.RspMsg
                  : "获取菜单信息失败!",
                type: "error",
              });
            });
        });
      } else if (this.SelectedMenu.TreeLevel == 0) {
        this.$message({
          showClose: true,
          message: "产品不能删除!",
          type: "error",
        });
      }
    },
    ParentMenuChange(value) {
      console.log(value);
      let nodesObj = this.$refs["ParentMenuCascader"].getCheckedNodes();
      if (nodesObj[0].data) {
        if (nodesObj[0].data.TreeLevel == 0) {
          this.ParentMenu = undefined;
          this.SelecedProductCode = nodesObj[0].data.TreeObj.ProductCode;
        } else {
          this.ParentMenu = nodesObj[0].data.TreeObj;
          this.SelecedProductCode = nodesObj[0].data.TreeObj.ProductCode;
        }
      }
    },
    onUp() {
      if (!this.SelectedMenu) {
        this.$message({
          showClose: true,
          message: "请选择要移动的项!",
          type: "error",
        });
        return;
      }

      var Order_Index = 0;

      if (this.SelectedMenu.TreeLevel == 0) {
        Order_Index = this.SelectedMenu.TreeObj.OrderIndex - 1;
      } else {
        Order_Index = this.SelectedMenu.TreeObj.MenuIndex - 1;
      }

      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;

      let TreeSearch = {
        OrgCode: OrgCode,
        UserId: userId,
        TreeLevel: this.SelectedMenu.TreeLevel,
        TreeId: this.SelectedMenu.TreeId,
        OrderIndex: Order_Index,
      };
      showLoading(".zj-form-container");
      new WebApis.TreeApi()
        .UpdateTreeOrderIndex(TreeSearch)
        .then((res) => {
          if (res.RspCode == "0") {
            hideLoading();
            this.$message({
              showClose: true,
              message: res.RspMsg,
              type: "error",
            });
          } else {
            hideLoading();
            let MenuIdArray = [];
            var MenuId = this.SelectedMenu.TreeId;
            MenuIdArray.push(MenuId);
            this.GetMenus(MenuIdArray);
          }
        })
        .catch((e) => {
          hideLoading();
          this.$message({ showClose: true, message: e.RspMsg, type: "error" });
        });
    },
    onDown() {
      if (!this.SelectedMenu) {
        this.$message({
          showClose: true,
          message: "请选择要移动的项!",
          type: "error",
        });
        return;
      }

      var Order_Index = 0;

      if (this.SelectedMenu.TreeLevel == 0) {
        Order_Index = this.SelectedMenu.TreeObj.OrderIndex + 1;
      } else {
        Order_Index = this.SelectedMenu.TreeObj.MenuIndex + 1;
      }

      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;

      let TreeSearch = {
        OrgCode: OrgCode,
        UserId: userId,
        TreeLevel: this.SelectedMenu.TreeLevel,
        TreeId: this.SelectedMenu.TreeId,
        OrderIndex: Order_Index,
      };

      showLoading(".zj-form-container");

      new WebApis.TreeApi()
        .UpdateTreeOrderIndex(TreeSearch)
        .then((res) => {
          if (res.RspCode == "0") {
            hideLoading();
            this.$message({
              showClose: true,
              message: res.RspMsg,
              type: "error",
            });
          } else {
            hideLoading();
            let MenuIdArray = [];
            var MenuId = this.SelectedMenu.TreeId;
            MenuIdArray.push(MenuId);
            this.GetMenus(MenuIdArray);
          }
        })
        .catch((e) => {
          hideLoading();
          this.$message({ showClose: true, message: e.RspMsg, type: "error" });
        });
    },
  },
};
</script>